import React, { useState } from 'react';
import Modal from '@amzn/awsui-components-console/modal';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import FormField from '@amzn/awsui-components-console/form-field';
import RadioGroup from '@amzn/awsui-components-console/radio-group';
import { ExportOptions, ExportFormat } from 'src/services/workflowExport/types';

export interface ExportDialogProps {
	isOpen: boolean;
	onClose: () => void;
	onExport: (options: ExportOptions) => void;
	workflowName: string;
	isExporting: boolean;
}

export default function ExportDialog({
	isOpen,
	onClose,
	onExport,
	workflowName,
	isExporting,
}: ExportDialogProps) {
	const [format, setFormat] = useState<ExportFormat>('json');

	const handleExport = () => {
		onExport({
			format,
		});
	};

	const handleClose = () => {
		setFormat('json');
		onClose();
	};

	return (
		<Modal
			visible={isOpen}
			onDismiss={handleClose}
			header="Export Workflow"
			closeAriaLabel="Close export dialog"
			footer={
				<Box float="right">
					<SpaceBetween direction="horizontal" size="xs">
						<Button variant="link" onClick={handleClose} disabled={isExporting}>
							Cancel
						</Button>
						<Button
							variant="primary"
							onClick={handleExport}
							loading={isExporting}
							data-testid="export-confirm-button"
						>
							Export
						</Button>
					</SpaceBetween>
				</Box>
			}
		>
			<SpaceBetween direction="vertical" size="l">
				<Box variant="p" color="text-body-secondary">
					Export <strong>{workflowName}</strong> workflow definition to a file.
				</Box>

				<FormField
					label="Export format"
					description="Choose the file format for the exported workflow definition."
				>
					<RadioGroup
						value={format}
						onChange={({ detail }) => setFormat(detail.value as ExportFormat)}
						items={[
							{
								value: 'json',
								label: 'JSON',
								description:
									'JavaScript Object Notation - widely supported format',
							},
							{
								value: 'yaml',
								label: 'YAML',
								description: 'Human-readable format - easier to edit manually',
							},
						]}
					/>
				</FormField>
			</SpaceBetween>
		</Modal>
	);
}
